import React from 'react';
import {Features} from 'client/common/types';

const FeaturesContext = React.createContext<Features>({});

export function useFeatures(): Features {
    return React.useContext(FeaturesContext);
}

export const FeaturesContextProvider = FeaturesContext.Provider;
